module.exports = __webpack_public_path__ + "ef2abccdd61216c467034ea3a05c6927.svg";